import React from 'react'
import PropTypes from 'prop-types'

import RuleChecklist from './RuleChecklist'
import RuleProgressBar from './RuleProgressBar'

import 'loyal-design-system/assets/css/template/password.css'

const testRules = (rules) => (password) =>
  Object.values(rules).map(({ name, regex }) => ({
    name,
    isValid: password.match(regex)
  }))

const PasswordStrength = ({
  rules = [
    {
      name: 'Conter caracteres especiais',
      regex: /[!@#$%^&*(),.?":{}|<>]/
    },
    {
      name: 'Conter letras minúsculas',
      regex: /[a-z]+/
    },
    {
      name: 'Conter letras maiúsculas',
      regex: /[A-Z]+/
    },
    { name: 'Conter números', regex: /\d/ },
    {
      name: 'Conter 8 caracteres ou mais',
      regex: /^.{8,}$/
    }
  ],
  password
}) => {
  rules = testRules(rules)(password)

  return (
    <div className="row mx-0">
      <div className="col-12 mb-1 px-0 mt-2">
        <p className="txt-body-sm">
          <strong>Vamos ver se tua senha é forte:</strong>
        </p>
      </div>
      <RuleProgressBar rules={[...rules]} />
      <RuleChecklist rules={[...rules]} />
    </div>
  )
}

PasswordStrength.propTypes = {
  rules: PropTypes.array,
  password: PropTypes.string
}

export default PasswordStrength
